import React from 'react';
import PropTypes from 'prop-types';

function IconHome({ color = '#8C8C8C', size = 24, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10121_41206)">
        <path d="M3.75 20.25H20.25V11.25C20.2501 11.1515 20.2307 11.0539 20.1931 10.9628C20.1555 10.8718 20.1003 10.7891 20.0306 10.7194L12.5306 3.21935C12.461 3.14962 12.3783 3.0943 12.2872 3.05656C12.1962 3.01882 12.0986 2.99939 12 2.99939C11.9014 2.99939 11.8038 3.01882 11.7128 3.05656C11.6217 3.0943 11.539 3.14962 11.4694 3.21935L3.96938 10.7194C3.89975 10.7891 3.84454 10.8718 3.8069 10.9628C3.76926 11.0539 3.74992 11.1515 3.75 11.25V20.25Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_10121_41206">
          <rect width={size} height={size} fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

IconHome.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconHome;
